export const CalendarClock = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.04939 8.29713L2.98998 13.6315C3.14982 14.538 4.01425 15.1433 4.92074 14.9834L8.42778 14.365M2.04939 8.29713L1.75997 6.65578C1.60014 5.74929 2.20542 4.88486 3.11191 4.72502L10.9083 3.35031C11.8148 3.19047 12.6792 3.79575 12.8391 4.70224L13.1285 6.34358L2.04939 8.29713ZM13.3325 9.79187V11.6669L14.9992 13.3335M18.5409 11.6669C18.5409 14.5434 16.209 16.8752 13.3325 16.8752C10.4561 16.8752 8.12421 14.5434 8.12421 11.6669C8.12421 8.79039 10.4561 6.45854 13.3325 6.45854C16.209 6.45854 18.5409 8.79039 18.5409 11.6669Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CalendarClock
